import { createContext } from 'react';

import { Config } from './config';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const EnvConfigContext = createContext<Config>(null!); // This will never be null, since it's being guarded in the provider
